import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["presetSelect", "hiddenInput", "customWrapper", "customInput"]

  declare presetSelectTarget: HTMLSelectElement
  declare hiddenInputTarget: HTMLInputElement
  declare customWrapperTarget: HTMLElement
  declare customInputTarget: HTMLInputElement

  connect() {
    this.initializeSelection()
  }

  initializeSelection() {
    const currentValue = this.hiddenInputTarget.value
    const presetValues = ["", "15", "30", "60"]

    if (!currentValue || presetValues.includes(currentValue)) {
      this.presetSelectTarget.value = currentValue || ""
      this.customWrapperTarget.hidden = true
    } else {
      this.presetSelectTarget.value = "custom"
      this.customInputTarget.value = currentValue
      this.customWrapperTarget.hidden = false
    }
  }

  onChange(event?: Event) {
    const value = this.presetSelectTarget.value
    if (value === "custom") {
      this.customWrapperTarget.hidden = false
      this.hiddenInputTarget.value = this.customInputTarget.value || ""
      // Picking "Custom" with no value yet is a transient state; don't let the
      // change bubble to the auto-saving form, or it persists a blank (which
      // means "timeout disabled") before the user types their number.
      if (!this.customInputTarget.value) event?.stopPropagation()
    } else {
      this.customWrapperTarget.hidden = true
      this.hiddenInputTarget.value = value
    }
  }

  syncCustom() {
    this.hiddenInputTarget.value = this.customInputTarget.value
  }
}
